import * as THREE from 'three';

export function superellipse(rx, rz, nFront = 8, nBack = 2.4, segs = 48, ox = 0) {
  const pts = [];
  for (let i = 0; i < segs; i++) {
    const theta = (i / segs) * Math.PI * 2;
    const c = Math.cos(theta);
    const s = Math.sin(theta);
    const n = s >= -0.05 ? nFront : nBack;
    const x = ox + rx * Math.sign(c || 1) * Math.pow(Math.abs(c), 2 / n);
    const z = rz * Math.sign(s || 1) * Math.pow(Math.abs(s), 2 / n);
    pts.push(new THREE.Vector2(x, z));
  }
  return pts;
}

export function loft(profiles, { closed = true, cap = true } = {}) {
  const rings = profiles.length;
  const segs = profiles[0].points.length;
  const pos = [];
  const uv = [];
  const idx = [];

  for (let i = 0; i < rings; i++) {
    const p = profiles[i];
    for (let j = 0; j < segs; j++) {
      const q = p.points[j];
      pos.push(q.x, p.y, q.y);
      uv.push(j / segs, i / Math.max(1, rings - 1));
    }
  }

  const ringWrap = closed ? segs : segs - 1;
  for (let i = 0; i < rings - 1; i++) {
    for (let j = 0; j < ringWrap; j++) {
      const j2 = closed ? (j + 1) % segs : j + 1;
      const a = i * segs + j;
      const b = i * segs + j2;
      const c = (i + 1) * segs + j2;
      const d = (i + 1) * segs + j;
      idx.push(a, d, b, b, d, c);
    }
  }

  if (cap) {
    const centroid = (ringIndex) => {
      let x = 0;
      let z = 0;
      const base = ringIndex * segs;
      for (let j = 0; j < segs; j++) {
        x += pos[(base + j) * 3];
        z += pos[(base + j) * 3 + 2];
      }
      return [x / segs, profiles[ringIndex].y, z / segs];
    };

    const addCap = (ringIndex, flip) => {
      const ci = pos.length / 3;
      const [cx, cy, cz] = centroid(ringIndex);
      pos.push(cx, cy, cz);
      uv.push(0.5, ringIndex === 0 ? 0 : 1);
      const base = ringIndex * segs;
      for (let j = 0; j < segs; j++) {
        const j2 = (j + 1) % segs;
        if (flip) idx.push(ci, base + j2, base + j);
        else idx.push(ci, base + j, base + j2);
      }
    };

    addCap(0, true);
    addCap(rings - 1, false);
  }

  const geo = new THREE.BufferGeometry();
  geo.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
  geo.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
  geo.setIndex(idx);
  geo.computeVertexNormals();
  return geo;
}

export function tube(points, radius, radial = 7, tubular = 20) {
  const curve = new THREE.CatmullRomCurve3(points, false, 'catmullrom', 0.15);
  return new THREE.TubeGeometry(curve, tubular, radius, radial, false);
}

export function makePeg({
  length = 0.046,
  shaftR = 0.0042,
  headR = 0.011,
  headLen = 0.018,
  segments = 24,
} = {}) {
  const pts = [];
  pts.push(new THREE.Vector2(0.0004, 0));
  pts.push(new THREE.Vector2(shaftR * 0.92, 0.002));
  pts.push(new THREE.Vector2(shaftR, length - headLen - 0.003));
  pts.push(new THREE.Vector2(headR * 0.55, length - headLen));
  pts.push(new THREE.Vector2(headR, length - headLen * 0.62));
  pts.push(new THREE.Vector2(headR * 0.86, length - headLen * 0.28));
  pts.push(new THREE.Vector2(headR * 0.42, length - 0.002));
  pts.push(new THREE.Vector2(0.001, length));
  const geo = new THREE.LatheGeometry(pts, segments);
  geo.rotateZ(-Math.PI / 2);
  return geo;
}

export function makeSundari(r = 0.0032) {
  const geo = new THREE.RingGeometry(r * 0.42, r, 18);
  return geo;
}
